<script lang="ts" setup>
const { locale } = useI18n()
const route = useRoute()
const useCasesStore = useUseCasesStore()

watch(
  () => route.params.slug,
  () => useCasesStore.resetStore(),
  { immediate: true },
)

const { data } = await useFetch<{
  document: (ParsedContent & { schema?: any })
  surround: {
    after?: ParsedContent
    before?: ParsedContent
  }
}>(`/api/server/content/${route.params.slug}?locale=${locale.value}&collection=use-cases`)

useSeoMeta({
  description: data.value?.document?.description,
  title: `${data.value?.document?.title} - The Companies API`,
})
</script>

<template>
  <!-- <UseCaseNavigation class="mb-6" /> -->

  <template v-if="data?.document">
    <UseCaseCard
      :authors="data.document.authors"
      :description="data.document.description"
      :reading-time="data.document.readingTime.text"
      :schema="data.document.schema"
      :tags="data.document.tags"
      :title="data.document.title"
      :trophies="data.document.trophies"
      :youtube-id="data.document.youtubeId"
    />

    <UPageBody
      class="mb-8 pb-0"
      prose
    >
      <ContentRenderer
        class="grid grid-cols-1 gap-6 xl:gap-8"
        :data="useCasesStore.markdownVariables"
        :value="data.document"
      />
    </UPageBody>

    <!-- <template v-if="data?.surround?.before || data?.surround?.after">
      <BaseHeading
        class="mb-12 mt-24"
        :description="t('suggestions.description')"
        has-glow
        size="lg"
        :title="t('suggestions.title')"
      />

      <div class="grid grid-flow-dense grid-cols-1 grid-rows-2 gap-4 md:grid-cols-2 md:grid-rows-1">
        <UseCaseCard
          v-if="data.surround.before"
          :key="`${data?.document?.slug}-${locale}`"
          :authors="data.surround.before.authors"
          class="h-[240px] md:h-[320px] md:max-h-[320px]"
          :description="data.surround.before.description"
          :reading-time="data.surround.before.readingTime.text"
          :slug="data.surround.before._path?.split('/').pop()"
          :tags="data.surround.before.tags"
          :title="data.surround.before.title"
        />

        <div v-else />

        <UseCaseCard
          v-if="data.surround.after"
          :key="`${data?.document?.slug}-${locale}`"
          :authors="data.surround.after.authors"
          class="h-[240px] md:h-[320px] md:max-h-[320px]"
          :description="data.surround.after.description"
          :reading-time="data.surround.after.readingTime.text"
          :slug="data.surround.after._path?.split('/').pop()"
          :tags="data.surround.after.tags"
          :title="data.surround.after.title"
        />

        <div v-else />
      </div>
    </template> -->
  </template>
</template>

<i18n lang="json">
{
  "en": {
    "suggestions": {
      "description": "And don’t hesitate to reach out if you need one that you can’t find.",
      "title": "Discover our other use cases"
    }
  },
  "es": {
    "suggestions": {
      "description": "Y no dudes en contactarnos si necesitas algo que no encuentres.",
      "title": "Descubre nuestros otros casos de uso"
    }
  },
  "fr": {
    "suggestions": {
      "description": "Et n’hésitez pas à nous contacter si vous avez besoin de quelque chose que vous ne trouvez pas.",
      "title": "Découvrez nos autres cas d'utilisation"
    }
  }
}
</i18n>
